import React from 'react';
import { useTranslations } from 'next-intl';

import { StyledVideoSkeleton } from './video.style';

const VideoSkeleton = () => {
  const t = useTranslations();
  return <StyledVideoSkeleton>{t('video.loading')}</StyledVideoSkeleton>;
};

export default VideoSkeleton;
